import { selectUser, selectUserShortcuts } from 'containers/Login/loginSlice'
import ActionsButton from 'components/ActionsButton'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { getIcon, getPath } from './constans'
import { displayPrice } from 'utils/string'
import { useSelector } from 'react-redux'
import Error from 'components/Error'
import { Fragment } from 'react'

const Shortcuts = () => {
  const user = useSelector(selectUser)
  const shortcuts = useSelector(selectUserShortcuts)
  const userHasUnpaidInvoices = Array.isArray(user?.unpaid_invoices) && user.unpaid_invoices.length > 0

  const { t } = useTranslation('dashboard')
  const { push } = useHistory()

  const renderActionButton = (index) => {
    const value = shortcuts[index]?.value
    return value
      ? <ActionsButton
        text={`${t(value)}${(value === 'payments' && user.unpaidInvoicesAmount)
          ? ` (${displayPrice(user.unpaidInvoicesAmount)})`
          : ''}`}
        Icon={getIcon(value)}
        additionalText={value === 'invoices' && userHasUnpaidInvoices
          ? `${user?.unpaid_invoices?.length}`
          : undefined}
        action={() => {
          push(getPath(value))
        }} />
      : null
  }

  return (
    <div className='dashboard__shortcuts'>
      {shortcuts && shortcuts.length > 0
        ? <div className='actionsButton__buttons'>
          {shortcuts?.map((_, idx) => {
            if (idx !== 0 && idx !== 3) return null
            return <Fragment key={idx}>
              <div className='buttons__row center'>
                {renderActionButton(idx)}
                {shortcuts[idx + 1] && <hr />}
                {renderActionButton(idx + 1)}
                {shortcuts[idx + 2] && <hr />}
                {renderActionButton(idx + 2)}
              </div>
              {!idx && shortcuts.length > 3 && <hr />}
            </Fragment>
          })}
        </div>
        : <Error
          staticPos
          text={t('noShortcuts')}
        />}
    </div>
  )
}

export default Shortcuts
